import { Link, useParams } from 'react-router-dom';
import { BandeauAlerte } from '../../components/index.js';
import { useChargement } from '../../hooks/useChargement.js';
import { api } from '../../lib/api.js';
import { VueParcours, type DonneesParcours } from '../public/Parcours.js';

/** Aperçu organisateur du parcours d'un foyer, tel que le participant le verra (adresses visibles). */
export function ApercuParcours() {
  const { eventId, householdId } = useParams<{ eventId: string; householdId: string }>();
  const { donnees, erreur } = useChargement(() => api.get<DonneesParcours>(`/api/events/${eventId}/parcours/${householdId}`), [eventId, householdId]);
  return (
    <div className="page-app">
      <div className="entete-page">
        <div>
          <h1 className="display">Aperçu du parcours</h1>
          <p className="texte-doux">Ce que verra cette voiture sur son téléphone. Ici, les adresses sont toujours visibles.</p>
        </div>
        <Link className="btn" to={`/app/e/${eventId}/diffusion`}>
          ← Diffusion
        </Link>
      </div>
      {erreur ? <BandeauAlerte niveau="attention" role="alert" titre={erreur} /> : null}
      {donnees ? (
        <div className="cadre-telephone">
          <VueParcours data={donnees} />
        </div>
      ) : null}
    </div>
  );
}
